import {
  TextField as MuiTextField,
  Radio,
  Button as MuiButton,
} from '@material-ui/core';
import styled from 'styled-components';

const RadioItem = styled(Radio)`
  display: block;
  white-space: normal;
  min-height: 30px;
  line-height: 30px;
`;

const TextField = styled(MuiTextField)`
  font-size: 16px;
  width: 100%;
  padding: 8px;
`;

const Button = styled(MuiButton)`
  margin: 12px;
`;

export default {
  RadioItem,
  TextField,
  Button,
};
